module.exports = __webpack_public_path__ + "img/08_Lichttechnik@2x.f78251b1.jpg";